// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-449d1c83] {\n  --magic-header: var(--static-page-content-header-color, var(--magic-tertiary, #311261));\n  --magic-text-primary: var(--magic-tertiary, #311261);\n  color: var(--static-page-content-color, var(--magic-tertiary, #311261));\n}\n\n [data-v-449d1c83-host].loyalty-page-content .wrapper,:host(.loyalty-page-content) .wrapper {\n  max-width: initial;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
